import script from "./PlanFormListView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanFormListView.vue?vue&type=script&setup=true&lang=js"

import "./PlanFormListView.vue?vue&type=style&index=0&id=54d4ca85&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d4ca85"]])

export default __exports__